
























import {Component, Vue} from "vue-property-decorator";
import Header from './Header.vue'
import {Getter, State} from "vuex-class";

@Component({
    components: {Header}
})
export default class PublicPage extends Vue {

    @State('showLeftMenu')
    private showLeftMenu!: boolean

    @State
    private errorMessage!: string

    @Getter
    private showErrorMessage!: boolean

    width = 320

    closeErrorDialog() {
        this.$store.commit('setErrorMessage')
    }

    initDrawerResize() {
        const el = (this.$refs.drawer as Vue & any | undefined)?.$el

        if (!el) {
            return
        }

        const border = el.querySelector(".v-navigation-drawer__border")

        if (!border) {
            return
        }

        const context = this
        const borderWidth = 3

        function mousedown(e: any) {
            if (e.offsetX < borderWidth) {
                el!.style.transition = 'initial';
                document.addEventListener("mousemove", mousemove, false);
                document.addEventListener("mouseup", mouseup, false);
            }
        }

        function mousemove(e: any) {
            document.body.style.cursor = "ew-resize"
            context.width = e.clientX
        }

        function mouseup() {
            el!.style.transition = '';
            document.body.style.cursor = "";
            document.removeEventListener("mousemove", mousemove, false);
            document.removeEventListener("mouseup", mouseup, false);
        }

        border.addEventListener("mousedown", mousedown, false)
    }

    mounted() {
        this.initDrawerResize()
    }

}
